var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#27D639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 8H8.58333C7.7125 8 7.00792 8.7125 7.00792 9.58333L7 23.8333L10.1667 20.6667H21.25C22.1208 20.6667 22.8333 19.9542 22.8333 19.0833V9.58333C22.8333 8.7125 22.1208 8 21.25 8ZM19.6667 17.5H10.1667V15.9167H19.6667V17.5ZM19.6667 15.125H10.1667V13.5417H19.6667V15.125ZM19.6667 12.75H10.1667V11.1667H19.6667V12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMessageIcon);
export default __webpack_public_path__ + "static/media/greenMessageIcon.784008e8ecd2c1de2326749643df77a0.svg";
export { ForwardRef as ReactComponent };